import { CompanyCell } from "./CompanyCell/CompanyCell";
import { InvestorsCell } from "./InvestorsCell/InvestorsCell";
import { FinancialStageCell } from "./FinancialStageCell/FinancialStageCell";
import { ValuationCell } from "./ValuationCell/ValuationCell";
import { TotalFundingCell } from "./TotalFundingCell/TotalFundingCell";
import { LocationCell } from "./LocationCell/LocationCell";
import { WebsiteCell } from "./WebsiteCell/WebsiteCell";
import styles from "./RowCell.module.scss";
import { headers } from "../TableLabels/const/const";
import { PipelineStageCell } from "./PipelineStageCell/PipelineStageCell";
import {
  TCompanyComparedDetails,
  TCompanyDetails
} from "@/frontend/pages/ExpertPortfolioCompanyProfilePage/model/types/types";
import { TagsCell } from "@/frontend/pages/ExpertRootPage/ui/RowCell/TagsCell/TagsCell";

type TRowCellProps = {
  colId: string;
  data: TCompanyDetails;
};

type TCompanyIndexable = TCompanyDetails & { [key: string]: any };

export function RowCell({ colId, data }: TRowCellProps) {
  const field = (data as TCompanyIndexable)[colId];
  const harmonicData = data?.companyData;

  function getFilledPortfolioCompanyData(): TCompanyComparedDetails {
    const result: TCompanyComparedDetails = {
      headline: "",
      name: "",
      city: "",
      country: "",
      description: "",
      id: 0,
      state: "",
      website: ""
    };

    if (data?.companyData) {
      Object.keys(data.companyData).forEach((key) => {
        result[key] = data.companyData[key];
      });
    }

    if (data) {
      Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value !== undefined && value !== null && value !== "") {
          result[key] = value;
        }
      });
    }

    return result;
  }

  const companyData = getFilledPortfolioCompanyData();

  switch (colId) {
    case "name":
      return <CompanyCell field={companyData} />;
    case "tags":
      return <TagsCell tags={companyData.CompaniesTags} />;
    case "stage":
      return <PipelineStageCell field={{ name: companyData?.stage?.name || "" }} />;
    case "financialStage":
      return <FinancialStageCell field={harmonicData?.financialStage} />;
    case "valuation":
      return <ValuationCell field={field} />;
    case "totalFunding":
      return <TotalFundingCell field={data?.totalFunding || harmonicData?.totalFunding} />;
    case "investors":
      return <InvestorsCell field={harmonicData?.harmonicInvestors || []} />;
    case "city":
      return <LocationCell field={data?.city || data?.country ? data : harmonicData} />;
    case "website":
      return <WebsiteCell field={harmonicData?.website} />;
    default:
      return null;
  }
}

// Should be fixed - for now we dont have these fields from BE - A.

// @ts-ignore
export function buildCells(portfolioCompany: TCompanyDataInOrg) {
  return headers.map((header) => (
    <div key={header.key} className={styles.cell}>
      <RowCell data={portfolioCompany} colId={header.key} />
    </div>
  ));
}
